"use client";

import React from "react";

import Button, { ButtonSize, ButtonTheme, ButtonVariant } from "@/components/ui/Button/Button";
import useMediaQuery from "@/hooks/useMediaQuery";

import RichText from "../RichText/RichText";
import RichTextForBlog from "../RichTextForBlogs/RichTextForBlog";
import { EditorialModuleText2 as EditorialModuleText2Type } from "./type";

export interface EditorialModuleText2Props {
  entry: EditorialModuleText2Type;
  typeIndex?: number;
}

export default function EditorialModuleText2({ entry, typeIndex }: EditorialModuleText2Props) {
  const isMobile = useMediaQuery("(max-width: 600px)");
  return (
    <div
      className={`h-full flex flex-col justify-center md:mx-[40px] px-m 
        ${isMobile ? "py-[60px]" : "py-[10px]"}
        md:py-[40px] gap-xl md:gap-xl`}
    >
      <div className="flex flex-col justify-center md:gap-xl my-m">
        {entry.title && typeIndex === 1 ? (
          <h1 className={`uppercase font-primary text-l font-medium ${isMobile ? "mb-[10px]" : ""}`}>{entry.title}</h1>
        ) : (
          <p className={`uppercase font-primary text-l font-medium ${isMobile ? "mb-[10px]" : ""}`}>{entry.title}</p>
        )}
        {entry.tags && entry.tags.length > 0 && (
          <div className="flex flex-col md:flex-row gap-xs">
            {entry.tags.map((item, index) => (
              <label className="bg-gold-40 rounded w-fit leading-none p-[6px]" key={index}>
                {item}
              </label>
            ))}
          </div>
        )}
        {/* {entry.body && <RichText content={entry.body} />} */}
        {entry.body && <RichTextForBlog content={{ html: entry?.body?.html }} leadFormPageLocation="SEO Sale Page Lead Form" />}
      </div>
      {entry.ctas && entry.ctas.length > 0 && (
        <div className="flex flex-col justify-center items-center md:flex-row md:justify-normal gap-m md:gap-l">
          {entry.ctas[0] && (
            <Button
              href={entry.ctas[0].link.url}
              customClass="md:whitespace-nowrap"
              type="button"
              size={ButtonSize.MEDIUM}
              variant={ButtonVariant.PRIMARY}
              theme={ButtonTheme.BLACK}
            >
              {entry.ctas[0].label}
            </Button>
          )}
          {entry.ctas[1] && (
            <Button
              href={entry.ctas[1].link.url}
              customClass="md:flex md:whitespace-nowrap"
              type="button"
              size={ButtonSize.MEDIUM}
              variant={ButtonVariant.PRIMARY}
              theme={ButtonTheme.WHITE}
            >
              {entry.ctas[1].label}
            </Button>
          )}
        </div>
      )}
    </div>
  );
}
